import { FC, useMemo } from "react";
import { Item, ItemProps } from ".";

interface ColorProps extends ItemProps {
    value?: string;
    onChange?: (value?: string) => void;
    placeholder?: string;
}
const Color: FC<ColorProps> = ({ value, onChange, col, error, label, placeholder, required, itemClassName, readOnly, helper, }) => {
    const inputClassName = useMemo(() => {
        let className = "@app-form-color w-full border px-4 py-2 rounded focus:outline-none focus:border-blue-500";
        if (Boolean(error)) {
            className += " border-red-500 focus:border-red-500 focus:ring-red-500";
        }
        return className;
    }, [error])
    return <Item col={col} label={label} required={required} error={error} itemClassName={itemClassName} helper={helper}>
        <input
            readOnly={readOnly}
            value={value || ""}
            onChange={e => onChange && onChange(e.currentTarget.value)}
            type="text"
            className={inputClassName}
            placeholder={placeholder}
        />
        <input
            className="absolute right-[10px] h-[20px] w-[50px] mt-[10px] cursor-pointer"
            type="color"
            value={value || ""}
            onChange={e => onChange && onChange(e.currentTarget.value)}
        />
    </Item >
}
export default Color;